var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, } from "@fortawesome/pro-solid-svg-icons";
import { usePopup } from "@/hooks/layout/popup";
import { useTranslation } from "react-i18next";
import { faBahai, faContactBook, faUsers, } from "@fortawesome/pro-regular-svg-icons";
export default function RemindersInvitee(_a) {
    var _this = this;
    var invitee = _a.invitee, remindersData = _a.remindersData, setRemindersData = _a.setRemindersData, removeReminder = _a.removeReminder, reminder = _a.reminder, index = _a.index, updateErrorMsg = _a.updateErrorMsg, appStrings = _a.appStrings;
    var t = useTranslation(["Meetings", "Calls", "common"]).t;
    /*useEffect(() => {
      setNewInvitee(reminder, reminder.invitees);
    }, [reminder]);*/
    var removeInvitee = function (i) {
        var newInvitee = reminder.invitees.filter(function (item, ind) {
            return i !== ind;
        });
        setNewInvitee(reminder, newInvitee);
    };
    var setNewInvitee = function (reminder, newInvitee) {
        var temp = __assign(__assign({}, reminder), { invitees: newInvitee });
        var newReminders = remindersData.map(function (item) {
            return item.id === reminder.id ? temp : item;
        });
        setRemindersData(newReminders);
    };
    var _b = usePopup(), showPopup = _b.showPopup, closePopup = _b.closePopup;
    var rmInvitee = function (texte) { return __awaiter(_this, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    removeInvitee(index);
                    if (!(reminder.invitees.length === 1)) return [3 /*break*/, 2];
                    return [4 /*yield*/, showPopup({
                            type: "dev/popup/confirm",
                            payload: {
                                title: reminder.invitees.length === 1 ? texte : texte,
                                content: " ",
                                buttons: {
                                    confirm: "Oui",
                                    cancel: "Non",
                                },
                            },
                        })];
                case 1:
                    result = _a.sent();
                    if ((result === null || result === void 0 ? void 0 : result.reason) === "confirm") {
                        removeReminder(index);
                        closePopup("null", "null");
                    }
                    else {
                        updateErrorMsg(appStrings["ERR_NO_INVITEES_FOR_REMINDER"]);
                        closePopup("null", "null");
                    }
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    return (_jsx("li", __assign({ className: "invitees_item" }, { children: _jsxs("div", __assign({ className: "invitee_btn btn btn-danger flex flex-row", "data-invitee-id": invitee.id, "data-id": invitee.module_id, "data-module": invitee.module }, { children: [_jsx("span", { className: "suitepicon suitepicon-module-users" }), _jsxs("span", __assign({ className: "pr-1 text-white" }, { children: [invitee.module === "Users" && (_jsx(FontAwesomeIcon, { icon: faUsers })), invitee.module === "Contacts" && (_jsx(FontAwesomeIcon, { icon: faContactBook })), invitee.module === "Leads" && (_jsx(FontAwesomeIcon, { icon: faBahai }))] })), _jsx("span", __assign({ className: "related-value text-white uppercase" }, { children: invitee.value })), _jsx("span", __assign({ title: t("LBL_DELETE", { ns: "common" }) || "Remove", onClick: function (e) {
                        rmInvitee(appStrings["LBL_DELETE_REMINDER_CONFIRM"]);
                    } }, { children: _jsx(FontAwesomeIcon, { icon: faClose, className: "ml-2 cursor-pointer text-white" }) }))] })) })));
}
